import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dismiss() {
    this.element.style.opacity = '0'
    this.element.style.transform = 'translateX(12px)'
    setTimeout(() => this.element.remove(), 200)
  }

  connect() {
    this._timeout = setTimeout(() => this.dismiss(), 5000)
  }

  disconnect() {
    clearTimeout(this._timeout)
  }
}
